export default __webpack_public_path__ + "static/media/final.750dde9c.wav";